// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    PutTranslateConfigsByIdParam,
    PutTranslateConfigsByIdBody,
    BaseResponseVoid,
    DeleteTranslateConfigsByIdParam,
} from '../../types';

/**
 * update
 *
 * @export
 * @tags translate-config-controller
 * @link [PUT] /translateConfigs/{id}
 * @param id
 */
export function putTranslateConfigsById(
    data: PutTranslateConfigsByIdBody,
    options: ApiOptions<PutTranslateConfigsByIdParam, never> & {
        segments: PutTranslateConfigsByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<PutTranslateConfigsByIdBody, PutTranslateConfigsByIdParam, never>(
        '/translateConfigs/{id}',
        { ...options, data, method: 'put', __$requestCalleeName: 'putTranslateConfigsById' }
    );
}

/**
 * deleteById
 *
 * @export
 * @tags translate-config-controller
 * @link [DELETE] /translateConfigs/{id}
 * @param id
 */
export function deleteTranslateConfigsById(
    options: ApiOptions<DeleteTranslateConfigsByIdParam, never> & {
        segments: DeleteTranslateConfigsByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, DeleteTranslateConfigsByIdParam, never>('/translateConfigs/{id}', {
        ...options,
        method: 'delete',
        __$requestCalleeName: 'deleteTranslateConfigsById',
    });
}

export const meta = [
    { tags: ['translate-config-controller'], path: '/translateConfigs/{id}', method: 'put' },
    { tags: ['translate-config-controller'], path: '/translateConfigs/{id}', method: 'delete' },
];
